"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _ProfileFormComponent = _interopRequireDefault(require("./ProfileFormComponent"));
var _userSelectors = require("../../../../../redux/selectors/userSelectors");
var _userProfileFormActions = require("../../../../../redux/actions/userProfileFormActions");
var _config = _interopRequireDefault(require("../../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useEmailAsUsername = _config["default"].SignupForm.useEmailAsUsername;
var ProfileForm = (0, _reduxForm.reduxForm)({
  form: 'userProfileForm',
  enableReinitialize: true,
  onSubmit: function onSubmit(payload, dispatch) {
    return dispatch((0, _userProfileFormActions.submitUserProfileForm)(payload));
  }
})(_ProfileFormComponent["default"]);
var mapStateToProps = function mapStateToProps(state) {
  var form = state.form,
    userInfo = state.user.userInfo;
  var editIsDisabled = (0, _userSelectors.isProfileSectionEditingDisabled)(state);
  return {
    initialValues: {
      username: userInfo.UserName,
      email: userInfo.Email
    },
    formObj: form.userProfileForm ? form.userProfileForm.values : {},
    editIsDisabled: editIsDisabled,
    useEmailAsUsername: useEmailAsUsername
  };
};
var mapDispatchToProps = {
  goToStep: _userProfileFormActions.goToProfileFormStep
};
var ProfileFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProfileForm);
var _default = exports["default"] = ProfileFormContainer;